import { ROUTE } from "../../../routes";
import { WIDGET } from "@voltmoney/schema";
import { showNewForeClosureFlow } from "../../../configs/utils";
export const goBackAction = async (action, _datastore, { goBack, removeWidgets, navigate }) => {
    await removeWidgets(ROUTE.PLEDGE_HISTORY, [
        { id: "pledgeHistoryDC", type: WIDGET.PLEDGE_HISTORY }
    ]);
    const showNewForeclosure = await showNewForeClosureFlow();
    const fromInProgressProcess = action?.payload?.fromInProgressProcess;
    if (showNewForeclosure) {
        await goBack();
    }
    else if (fromInProgressProcess) {
        await navigate(ROUTE.FORECLOSURE, {
            fromInProgressProcess: fromInProgressProcess
        });
    }
    else {
        await goBack();
    }
};
export const needHelpAction = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.CONTACT_US_CARD);
};
export const goToDetailsScreen = async (action, _datastore, { navigate, removeWidgets, instrumentTrack }) => {
    instrumentTrack('PLEDGE_HISTORY_DETAILS_BUTTON_CLICKED');
    const pledgedDetails = action?.payload?.value;
    const fromInProgressProcess = action?.payload?.fromInProgressProcess;
    if (pledgedDetails?.totalValueOfUnpledgedAssets) {
        await removeWidgets(ROUTE.PLEDGE_HISTORY, [
            { id: "pledgeHistoryDC", type: WIDGET.PLEDGE_HISTORY }
        ]);
        navigate(ROUTE.PLEDGE_DETAILS, {
            pledgeDetails: action?.payload?.value,
            fromInProgressProcess: fromInProgressProcess
        });
    }
    else {
        await navigate(ROUTE.PRE_DASHBOARD_SCREEN, {
            fromRouteId: "PLEDGE_HISTORY",
            pledgeDetails: action?.payload?.value
        });
    }
};
